import cn from 'classnames';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './Button.module.scss';

const ButtonSize = ['S', 'M', 'L', 'Xl'];
const ButtonType = [
  'nlGradient',
  'snGradient',
  'tertiary',
  'primary',
  'secondary',
  'ghostRegular',
  'ghostTertiary',
  'ghostSn',
  'regular',
];

const Button = ({
  text,
  disabled,
  type,
  size,
  className,
  href,
  openNew,
  title,
  to,
  onClick,
  id,
  eleId,
  div,
  clickabled,
  download,
  isActive,
}) => {
  const classes = cn(
    styles.btn,
    styles[`size${size}`],
    styles[type],
    className,
    {
      [styles.disabled]: disabled,
      [styles.cannotClick]: !clickabled,
      [styles.isActive]: isActive,
    }
  );
  if (openNew) {
    return (
      <a
        href={href}
        className={classes}
        title={title}
        data-id={id}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    );
  } else if (href) {
    return (
      <a
        href={href}
        className={classes}
        title={title}
        data-id={id}
        download={download}
      >
        {text}
      </a>
    );
  } else if (to) {
    return (
      <Link to={to} className={classes} data-id={id}>
        {text}
      </Link>
    );
  } else if (div) {
    return <div className={classes}>{text}</div>;
  } else {
    return (
      <button className={classes} onClick={onClick} data-id={id} id={eleId}>
        {text}
      </button>
    );
  }
};
Button.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.oneOf(ButtonSize).isRequired,
  type: PropTypes.oneOf(ButtonType).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  openNew: PropTypes.bool,
  title: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string,
  eleId: PropTypes.string,
  div: PropTypes.bool,
  clickabled: PropTypes.bool,
  download: PropTypes.bool,
  isActive: PropTypes.bool,
};
Button.defaultProps = {
  text: 'button',
  size: 'M',
  type: 'primary',
  id: '',
  div: false,
  openNew: false,
  clickabled: true,
  download: false,
  isActive: false,
  disabled: false,
};

export default Button;
